import React from 'react';
import type { SVGPropsWithClassName } from './types';
import { colors } from '@/styles';

export function ReplyWithVideo({
  className = '',
  size = 16,
  title = 'Reply',
  fill = colors.recordRed,
}: SVGPropsWithClassName) {
  const height = Number(size) * 2.85;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19.73 12.47"
      version="1.1"
      height={height}
    >
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
              M316.2,391.8a1.43,1.43,0,0,0-.81-.77,1.45,1.45,0,0,0-1.1,0l-2.86,1.36v-.35a2.23,2.23,
              0,0,0-2.17-2.3H298.78a2.22,2.22,0,0,0-2.15,2.27v7.89a2.23,2.23,0,0,0,2.16,
              2.31h10.49a2.22,2.22,0,0,0,2.14-2.27v-.57l2.71,1.29a1.47,1.47,0,0,0,
              .77.2h0a1.55,1.55,0,0,0,1.45-1.59v-6.77A1.63,1.63,0,0,0,316.2,391.8ZM309.93,
              400a.74.74,0,0,1-.67.75H298.83a.75.75,0,0,1-.7-.78V392a.72.72,0,0,1,
              .67-.75h10.43a.75.75,0,0,1,.7.78Zm1.5-2.25v-3.67l3.4-1.66,0,6.88.05.08v0Z
          `}
        fill={fill}
        transform="translate(-296.63 -389.77)"
      />
    </svg>
  );
}
